<template>
  <div class="parent" :style="{ background: bg }">
    <div class="divBgLeft"></div>
    <div class="divBgBorder"></div>
    <div class="divContainer">
      <subject-flow-widge
        subject="人工智能"
        :project="name"
        :routerLink="routerLink"
      ></subject-flow-widge>
      <img src="./../img/subjectLogo.png" class="imgSubject" />
      <div class="divContent">
        <div class="divC">
          <img v-lazy="nameImg" class="imgName" />
          <div class="divDesc">{{ desc }}</div>
          <pre-publish-widge
            :data="date"
            color="rgba(0, 0, 0, 1)"
            bgColor="linear-gradient(
            -90deg,
            rgba(255, 39, 39, 1) 0%,
            rgba(254, 100, 19, 1) 100%
          )"
          ></pre-publish-widge>
        </div>
      </div>
      <div class="divProject">
        <div class="divIndustry">
          <div class="divContainer">
            <img class="divImg" :src="logo" />
            <span class="spanDesc">{{ logoDesc }}</span>
          </div>
        </div>
        <div class="divNum">
          <ul>
            <li v-for="(item, index) in itemList" :key="index">
              <p class="pNum">
                {{ item.num }} <em>{{ item.unit }}</em>
              </p>

              <p class="pDesc">{{ item.type }}</p>
            </li>
          </ul>
        </div>
        <div class="divVideo" @click="handleVideo(video)" v-if="video">
          <div class="divBox"></div>
          <div class="divTriangle">
            <img src="../img/video.png" />
          </div>
          <div class="videoDesc">项目介绍</div>
        </div>
      </div>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
  </div>
</template>

<script>
import MenuAdd from "./../../../../components/video";
import subjectFlowWidge from "./../../../../components/subjectFlowWidge";
import prePublishWidge from './../../common/components/prePublishWidge'
export default {
  components: {
    MenuAdd,
    subjectFlowWidge,
    prePublishWidge,
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    logo: {
      type: String,
      default: "",
    },
    logoDesc: {
      type: String,
      default: "",
    },
    itemList: {
      type: Array,
      default: () => {},
    },
    video: {
      type: String,
      default: "",
    },
    bg: {
      type: String,
      default: "linear-gradient(-180deg,rgba(7,6,47,1) 0%,rgba(63,9,30,1) 88%)",
    },
    nameImg: {
      type: String,
      default: "",
    },
    industryBg: {
      type: String,
      default: "img/ai/industryBg.png",
    },
  },
  computed: {
    routerLink() {
      return {
        path: "/ai"
      };
    },
  },
  methods: {
    handleVideo(url) {
      let obj = {
        url: url,
      };
      this.$refs.editMenu.dialogFormV(obj);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/headFirstWidget.scss";
</style>
